import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { WhyTokotetaSection } from '../components/WhyTokotetaSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { NewCTABanner } from '../components/NewCTABanner';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-text-main selection:bg-primary/20" data-id="element-306">
      <Header data-id="element-307" />
      <main data-id="element-308">
        <HeroSection data-id="element-309" />
        <ComparisonSection data-id="element-310" />
        <WhyTokotetaSection data-id="element-311" />
        <HowItWorksSection data-id="element-312" />
        <TestimonialsSection data-id="element-313" />
        <NewCTABanner data-id="element-314" />
      </main>
      <Footer data-id="element-315" />
    </div>;
}